import React, { useEffect } from "react";
import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockStatisticModel } from "../stockStatisticModel";
import { ISCMStockStatisticDetail } from "../stockStatisticTypes";
import { formatNum } from "@/utils/utils";
import { useRecordGoodsModel } from "./GoodsRecordsModal/recordGoodsModel";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys, setStockQueryModal,
        warehouseloadDataAll
    } = useStockStatisticModel();
    const { user: { shopId }, userBranch } = useGlobalModel();

    useEffect(() => {
        warehouseloadDataAll(shopId);
        loadData();
    }, []);

    const columns: ColumnsType<ISCMStockStatisticDetail> = [
        {
            title: '序号',
            width: 60,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '商品编号',
            width: 180,
            dataIndex: 'materialCode',
            fixed: "left",
            // render: (text: any, record: ISCMStockStatisticDetail) => <span
            //     style={{ cursor: "pointer", color: "#00f" }}
            //     onClick={(e) => {
            //         e.stopPropagation();
            //         setGoodsRecordModal({
            //             visible: true, materialCode: record.materialCode, materialName: record.materialName, inventoryQuantity: record.inventoryQuantity
            //         })
            //     }}>
            //     {text}</span >
        },
        {
            title: '商品名称',
            width: 200,
            dataIndex: 'materialName',
            fixed: "left",
        },
        {
            title: '替换编号',
            width: 180,
            dataIndex: 'replaceCode',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        },
        {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        },
        {
            title: '库存数量',
            width: 100,
            dataIndex: ["ci", "vrm", "bcm"].includes(userBranch) ? 'inventoryNum' : 'inventoryQuantity',
        }, {
            title: '占用库存',
            width: 80,
            dataIndex: ["ci", "vrm", "bcm"].includes(userBranch) ? 'inventoryOccupied' : 'occupyNum',
            render: (text: any, record: ISCMStockStatisticDetail) => <span
                style={{ cursor: "pointer", color: "#00f" }}
                onClick={(e) => {
                    // console.log(record);
                    e.stopPropagation();
                    if (text && +text > 0) {
                        setStockQueryModal(record);
                        return;
                    }
                    message.warning("没有占用库存");
                }}>
                {text}</span >
        }, {
            title: '可用库存',
            width: 80,
            render: (text, record) => {
                if (["ci", "vrm", "bcm"].includes(userBranch)) {
                    return +(record?.availableStock ?? 0)
                }
                else {
                    return +(record?.inventoryQuantity ?? 0) - +(record?.occupyNum ?? 0)
                }
            }


        }, {
            title: '最新进价',
            width: 100,
            dataIndex: ["ci", "vrm", "bcm"].includes(userBranch) ? 'latestPurPrice' : 'latestPurPrice',
            render: text => `￥${formatNum(text)}`
        }, {
            title: '库存成本',
            width: 100,
            dataIndex: ["ci", "vrm", "bcm"].includes(userBranch) ? 'latestAmount' : 'inventoryAmount',
            render: text => `￥${formatNum(text)}`
        },
        {
            title: '进货价格',
            width: 100,
            dataIndex: ["ci", "vrm", "bcm"].includes(userBranch) ? 'purchasePrice' : 'buyingPrice',
            render: text => `￥${formatNum(text)}`
        }, {
            title: '零售价格',
            width: 100,
            dataIndex: ["ci", "vrm", "bcm"].includes(userBranch) ? 'lateSalePrice' : 'sellingPrice',
            render: text => `￥${formatNum(text)}`
        },
        // {
        //     title: '批发价格',
        //     width: 100,
        //     dataIndex: 'distributorPrice',
        //     render: text => `￥${formatNum(text)}`
        // }, {
        //     title: '优惠价格',
        //     width: 100,
        //     dataIndex: 'repairPrice',
        //     render: text => `￥${formatNum(text)}`
        // },
        {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        },
        {
            title: '规格型号',
            width: 160,
            dataIndex: 'model',
        },
    ];
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}

